<template>
    <RentalsListingsShell>
        <HugeSpinner v-if="loadingDeactiveListings"/>
        <CardShell v-else>
            <BackLinkHeading text="Deactivated Listings" route="/active-listings" linkText="Active Listings" :sizeDependent="false"/>
            <div class="ph3 ph4-ns mv3">
                <div>These listings are not visible to the public.</div>
                <div class="mt2">To reactivate a listing, go into the listing and click <b>Reactivate.</b></div>
            </div>
            <ListingList v-if="deactiveListings" :imageLarge="['sm', 'lg']" route="/deactive-listing" :tools="deactiveListings" />
        </CardShell>
    </RentalsListingsShell>
</template>

<script>
import RentalsListingsShell from '@/components/rentalsListings/shared/RentalsListingsShell.vue';
import CardShell from '@/components/global/CardShell.vue';
import BackLinkHeading from '@/components/controls/BackLinkHeading.vue';
import ListingList from '@/components/global/ListingList.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapState, mapActions } from 'vuex';

export default {
    components: {
        RentalsListingsShell,
        CardShell,
        BackLinkHeading,
        ListingList,
        HugeSpinner
    },
    computed: {
        ...mapState('deactiveListings', [
            'deactiveListings',
            'loadingDeactiveListings'
        ])
    },
    methods: {
        ...mapActions('deactiveListings', ['getDeactiveListings'])
    },
    created: function() {
        this.getDeactiveListings();
    }
};
</script>
